export default "__VITE_ASSET__DjyK9o99__"